import React from "react";
import cx from "classnames";
import "./ExternalLink.scss";

type Props = {
  href: string;
  children: React.ReactNode;
  className?: string;
  newTab?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  isPreventOnClick?: boolean;
};

const ExternalLink = React.forwardRef<HTMLAnchorElement, Props>(
  ({ href, children, className, newTab = true, isPreventOnClick = true, onClick = (e) => e.preventDefault() }, ref) => {
    const classNames = cx("link-underline", className);

    return (
      <a
        href={href}
        className={classNames}
        ref={ref}
        {...(newTab && {
          target: "_blank",
          rel: "noopener noreferrer",
        })}
        {...(isPreventOnClick && {
          onClick,
        })}
      >
        {children}
      </a>
    );
  }
);

ExternalLink.displayName = "ExternalLink";

export default ExternalLink;
